import { useCallback, useEffect, Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import gymIcon from 'assets/icons/gym-gray.svg'
import { GymListTypes } from 'types/GymType'
import { InputWrapper, StyledInputText } from './styled'

interface IGymSearchProps<TItem> {
  salons: TItem[] | []
  setData: Dispatch<SetStateAction<TItem[] | []>>
  searchText: string
  setSearchText: Dispatch<SetStateAction<string>>
  type: GymListTypes
}

export default function GymListSearch<TItem>({
  salons,
  setData,
  searchText,
  setSearchText,
  type,
}: IGymSearchProps<TItem>) {
  const { t } = useTranslation()

  // Handle change event of search input
  const handleChange = (value: string) => {
    setSearchText(value)
    filterData(value)
  }

  // Filter salons by search text
  const filterData = useCallback(
    (value: string) => {
      const includeColumns = ['name']
      const lowercasedValue = value.toLowerCase().trim()
      if (lowercasedValue === '') setData(salons)
      else {
        const filteredData = salons?.filter((item: any) => {
          if (type === 'personal') {
            return Object.keys(item).some((key) =>
              includeColumns.includes(key)
                ? item[key as keyof TItem].toString().toLowerCase().includes(lowercasedValue)
                : false
            )
          } else if (type === 'group') {
            return item.gymLessonType?.name?.toLowerCase().includes(lowercasedValue)
          } else {
            return item.gymTrainer?.fullName?.toLowerCase().includes(lowercasedValue)
          }
        })
        setData(filteredData)
      }
    },
    [salons, setData, type]
  )

  useEffect(() => {
    filterData(searchText)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salons])

  const disabled = !salons?.length

  const placeholder = {
    personal: t('input-texts.search-gym-salon'),
    group: t('input-texts.search-group-lesson'),
    trainer: t('input-texts.search-pt'),
  }

  return (
    <InputWrapper className="p-input-icon-left">
      <img src={gymIcon} alt="gym-salon-search" className="input-icon" width={20} height={20} />
      <StyledInputText
        id="gym-salon-search"
        disabled={disabled}
        value={searchText}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={placeholder[type]}
      />
    </InputWrapper>
  )
}
